'use client';

import { useUser } from '@/hooks/useUser';
import theme from '@/theme';
import { AppConfig } from '@/utils/AppConfig';
import { Box, Container, Divider, GridLegacy as Grid, Typography } from '@mui/material';
import Link from 'next/link';
const Footer = () => {
  const {
    data: user
  } = useUser();

  // Define sidebar width for consistency
  const SIDEBAR_WIDTH = 240;
  return <Box component="footer" sx={{
    mt: 'auto',
    bgcolor: theme.palette.grey[900],
    color: 'white',
    py: 4,
    width: '100%',
    marginLeft: {
      xs: 0,
      md: user ? `${SIDEBAR_WIDTH}px` : 0
    },
    maxWidth: {
      xs: '100%',
      md: user ? `calc(100% - 240px)` : '100%'
    }
  }} data-sentry-element="Box" data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      <Container maxWidth="lg" data-sentry-element="Container" data-sentry-source-file="Footer.tsx">
        <Grid container spacing={4} data-sentry-element="Grid" data-sentry-source-file="Footer.tsx">
          <Grid item xs={12} md={5} data-sentry-element="Grid" data-sentry-source-file="Footer.tsx">
            <Typography variant="h6" fontWeight="bold" gutterBottom component="div" data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              CertResource.com
            </Typography>
            <Typography variant="body2" sx={{
            opacity: 0.7
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              Helping professionals achieve their certification goals with high-quality practice resources.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} data-sentry-element="Grid" data-sentry-source-file="Footer.tsx">
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom component="div" data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              Exams
            </Typography>
            <Typography variant="body2" component={Link} href="/practice-exams/AIF-C01" sx={{
            opacity: 0.7,
            mb: 1,
            display: 'block'
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              AWS AI Practitioner (AIF-C01) Practice Exam Questions
            </Typography>
            <Typography variant="body2" component={Link} href="/practice-exams/CLF-C02" sx={{
            opacity: 0.7,
            mb: 1,
            display: 'block'
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              AWS Cloud Practitioner (CLF-C02) Practice Exam Questions
            </Typography>
            <Typography variant="body2" component={Link} href="/practice-exams/SOA-C02" sx={{
            opacity: 0.7,
            mb: 1,
            display: 'block'
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              AWS SysOps Administrator (SOA-C02) Practice Exam Questions
            </Typography>
            <Typography variant="body2" component={Link} href="/practice-exams/MLA-C01" sx={{
            opacity: 0.7,
            mb: 1,
            display: 'block'
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              AWS Certified Machine Learning Engineer (MLA-C01) Practice Exam Questions
            </Typography>
            <Typography variant="body2" component={Link} href="/practice-exams/DEA-C01" sx={{
            opacity: 0.7,
            mb: 1,
            display: 'block'
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              AWS Certified Data Engineer (DEA-C01) Practice Exam Questions
            </Typography>
            <Typography variant="body2" component={Link} href="/practice-exams/DVA-C02" sx={{
            opacity: 0.7,
            mb: 1,
            display: 'block'
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              AWS Certified Developer (DVA-C02) Practice Exam Questions
            </Typography>
          </Grid>
          <Grid item xs={12} md={3} data-sentry-element="Grid" data-sentry-source-file="Footer.tsx">
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom component="div" data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              Company
            </Typography>
            {/* <Typography variant="body2" sx={{ opacity: 0.7, mb: 1 }}>
                About Us
              </Typography> */}
            <Typography variant="body2" sx={{
            opacity: 0.7,
            mb: 1
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              Contact
            </Typography>
            <Typography variant="body2" component={Link} href="/privacy-policy" sx={{
            opacity: 0.7,
            display: 'block',
            mb: 1
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              Privacy Policy
            </Typography>
            <Typography variant="body2" component={Link} href="/terms" sx={{
            opacity: 0.7,
            display: 'block',
            mb: 1
          }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
              Terms of Service
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{
        my: 3,
        bgcolor: 'rgba(255,255,255,0.1)'
      }} data-sentry-element="Divider" data-sentry-source-file="Footer.tsx" />
        <Typography variant="body2" sx={{
        opacity: 0.7,
        textAlign: 'center'
      }} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
          ©
          {' '}
          {new Date().getFullYear()}
          {` `}
          {AppConfig.name}
          . All rights reserved.
        </Typography>
      </Container>
    </Box>;
};
export default Footer;